import type { DiscoveredRouteModule } from '@/router/generator/types';

const PortalMailView = () => import('@/views/portal/MailView.vue');
const PortalMailIndexView = () => import('@/views/portal/mail/IndexView.vue');
const PortalMailThreadView = () => import('@/views/portal/mail/ThreadView.vue');

export const NAME_PORTAL_MAIL = 'PortalMail';
export const NAME_PORTAL_MAIL_INDEX = 'PortalMailIndex';
export const NAME_PORTAL_MAIL_THREAD = 'PortalMailThread';
export const PATH_PORTAL_MAIL = 'portal/mail';

export const route: DiscoveredRouteModule = {
  id: 'app.portal.mail',
  scope: 'app',
  moduleKey: 'mail',
  name: NAME_PORTAL_MAIL,
  path: PATH_PORTAL_MAIL,
  component: PortalMailView,
  redirect: { name: NAME_PORTAL_MAIL_INDEX },
  children: [
    { path: '', component: PortalMailIndexView, name: NAME_PORTAL_MAIL_INDEX, meta: { dataLoaders: ['project_mail', 'portal_base'] } },
    { path: 'thread/:threadId', component: PortalMailThreadView, name: NAME_PORTAL_MAIL_THREAD, meta: { dataLoaders: ['project_mail', 'portal_base'] } }
  ],
  meta: { requiresAuth: true },
  requiresFeature: 'mail'
};


